import { Modal } from '@mantine/core'

import { useMutation } from '@redwoodjs/web'

import { useAuth } from 'src/auth'
import { toast } from 'src/components/Overlays/Toast/Toast'
import { CONFIGURE_COMPANY } from 'src/graphql/companies.graphql'
import { unformatPhoneNumber } from 'src/lib/phone.utils'
import AddCompanyForm from './AddCompanyForm'

interface AddCompanyModalProps {
  opened: boolean
  close: () => void
  refetch: () => void
}

const AddCompanyModal = ({ opened, close, refetch }: AddCompanyModalProps) => {
  const { currentUser } = useAuth()
  const [configureCompany, { loading }] = useMutation(CONFIGURE_COMPANY, {
    onCompleted: () => {
      refetch()
      toast('Company configured successfully with employees!', 'success')
      close()
    },
    onError: (error) => {
      toast(
        error?.message ?? 'Unable to configure company, please try again.',
        'error',
        {
          userId: currentUser?.userId,
          employeeId:
            currentUser?.employeeId ?? currentUser?.currentEmployeeId,
          operation: 'addCompany',
        }
      )
    },
  })

  const onSubmit = (values) => {
    configureCompany({
      variables: {
        input: {
          ...values,
          phoneNumber: values.phoneNumber
            ? unformatPhoneNumber(values.phoneNumber)
            : null,
          companyPhoneNumber: values.companyPhoneNumber
            ? unformatPhoneNumber(values.companyPhoneNumber)
            : null,
          companyFaxNumber: values.companyFaxNumber
            ? unformatPhoneNumber(values.companyFaxNumber)
            : null,
        },
      },
    })
  }

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      withCloseButton={false}
      size="70%"
    >
      <AddCompanyForm onSave={onSubmit} saveLoading={loading} />
    </Modal>
  )
}

export default AddCompanyModal
